import styled from "styled-components"

export const Container = styled.div`
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
    .cjcLmT {
        justify-content: left;
        text-align: left;
        align-items: left;
    }
`;

export const Wrapper = styled.div`
align-items: left;
justify-content: left;
text-align: left;
`;